<script>
    import { appSettings } from "../../stores";
    import { createEventDispatcher } from 'svelte';
    import { navigate } from "svelte-routing";

    export let showMenu;
    export let showScanner;
    const dispatch = createEventDispatcher();

    function toggleMenu () {
        dispatch('toggleMenu');
    }

    function navigateBack () {
        // if($appSettings.parentPage) {
        navigate($appSettings.parentPage);
        // }
    }

    function navigateHome () {
        // if($appSettings.parentPage) {
        navigate("/");
        // }
    }

    function openScanner () {
        // dispatch('toggleScanner');
        alert("Funktion fehlt noch");
    }

</script>

<div class="container">
    <div class="narrow">        
        <button on:click={navigateHome} class="button round">
            <i class="icon icon-home light"></i>
        </button>
        <button on:click={navigateHome} class="button round">
            <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><rect id="_32" serif:id="32" x="0" y="0" width="32" height="32" style="fill:none;"/><g id="Ebene-1" serif:id="Ebene 1"><path d="M17.045,25.666l-0,-8.716c-0,-0.53 -0.468,-0.959 -1.045,-0.959c-0.577,0 -1.045,0.429 -1.045,0.959l-0,8.716c-0,0.529 0.468,0.959 1.045,0.959c0.577,-0 1.045,-0.43 1.045,-0.959" style="fill:#fff;fill-rule:nonzero;"/><path d="M20.041,9.409c-2.025,-0.346 -3.628,-1.949 -3.972,-3.976c-0.014,-0.077 -0.126,-0.077 -0.138,-0c-0.345,2.027 -1.944,3.63 -3.972,3.976c-0.077,0.013 -0.077,0.125 -0,0.138c2.028,0.345 3.627,1.945 3.972,3.975c0.012,0.077 0.124,0.077 0.138,0c0.344,-2.03 1.947,-3.63 3.972,-3.975c0.077,-0.013 0.077,-0.125 0,-0.138" style="fill:#fff;fill-rule:nonzero;"/></g></svg>
        </button>
        <!-- <span>
            {$appSettings.currentPageName}
        </span> -->
        <button on:click={toggleMenu} class="button round">
            {#if showMenu}
                <i class="icon icon-cancel-1 light"></i>
            {:else}
                <i class="icon icon-menu light"></i>
            {/if}
        </button>
    </div>
</div>

<style>
    .container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        z-index: 10;
        flex-grow: 0;
        flex-shrink: 0;
        background: #1A1A1A;
        /* background: #242424; */

        /* background: radial-gradient(circle at bottom, #242424 0%, #1A1A1A 100%); */
        box-shadow: 0 0 20px #00000050;
        /* background: linear-gradient(0, rgba(15,15,15,1) 0%, rgba(15,15,15,1) 60%, rgba(15,15,15,0) 100%); */
    }

    .narrow {
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 40rem;
        margin-left: auto;
        margin-right: auto;
        /* background: radial-gradient(circle at bottom, #303030 5%, #242424 30%, #1A1A1A 70%); */
        background-image: url("/images/bg/gradient_header.png");
        background-position: center bottom;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .button {
        display: block;
        background-color: transparent;
        box-shadow: none;
        border-radius: 50%;
        width: 3rem;
        height: 2.5rem;
        padding: 0.2rem;
        margin: 0.75rem;
        position: relative;
    }

    .hidden {
        visibility: hidden;
    }

    .light {
        color: #FFFFFFA0;
    }
</style>